import { render } from "./ArchiveView.vue?vue&type=template&id=fb8a4a86&scoped=true"
import script from "./ArchiveView.vue?vue&type=script&lang=js"
export * from "./ArchiveView.vue?vue&type=script&lang=js"

import "./ArchiveView.vue?vue&type=style&index=0&id=fb8a4a86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8a4a86"],['__file',"src/views/ArchiveView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb8a4a86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb8a4a86', __exports__)) {
    api.reload('fb8a4a86', __exports__)
  }
  
  module.hot.accept("./ArchiveView.vue?vue&type=template&id=fb8a4a86&scoped=true", () => {
    api.rerender('fb8a4a86', render)
  })

}


export default __exports__